import { articles, categories, type NewsArticle, type NewsCategory } from "@/mocks/news";

export function getCategoryBySlug(slug: string): NewsCategory | undefined {
  return categories.find((item) => item.slug === slug);
}

export function getCategoryName(slug: string): string {
  return getCategoryBySlug(slug)?.name ?? "资讯";
}

export function getArticleById(id: string): NewsArticle | undefined {
  return articles.find((item) => item.id === id);
}

export function getArticlesByCategory(slug: string): NewsArticle[] {
  return articles.filter((item) => item.category === slug);
}

export function getLatestArticles(limit = articles.length): NewsArticle[] {
  return [...articles]
    .sort((a, b) => (a.publishedAt < b.publishedAt ? 1 : -1))
    .slice(0, limit);
}

export function getHotArticles(limit = 6): NewsArticle[] {
  return [...articles].sort((a, b) => b.hot - a.hot).slice(0, limit);
}

export function getCategoryCount(slug: string): number {
  return getArticlesByCategory(slug).length;
}

export function searchArticles(keyword: string, limit = 6): NewsArticle[] {
  const key = keyword.trim().toLowerCase();
  if (!key) return [];
  return articles
    .filter(
      (item) =>
        item.title.toLowerCase().includes(key) ||
        item.summary.toLowerCase().includes(key) ||
        item.tags.some((tag) => tag.toLowerCase().includes(key)) ||
        getCategoryName(item.category).toLowerCase().includes(key),
    )
    .slice(0, limit);
}

export function getRelatedArticles(article: NewsArticle, limit = 3): NewsArticle[] {
  const sameCategory = articles.filter(
    (item) => item.id !== article.id && item.category === article.category,
  );
  const others = articles.filter(
    (item) => item.id !== article.id && item.category !== article.category,
  );
  return [...sameCategory, ...others].slice(0, limit);
}

export function formatHot(hot: number): string {
  if (hot >= 95) return "爆";
  if (hot >= 85) return "热";
  if (hot >= 70) return "荐";
  return "新";
}